import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useNavigate } from 'react-router-dom';

function HeroCarousel() {
  const navigate = useNavigate();

  const slides = [
    {
      id: 1,
      title: "Elegant Diamond Collection",
      description: "Discover our stunning collection of handcrafted diamond jewelry",
      image: "/images/banner_ring_img.jpeg",
      buttonText: "Shop Now",
      buttonLink: "/shop"
    },
    {
      id: 2,
      title: "Timeless Gold Pieces",
      description: "Explore luxury gold jewelry that defines sophistication",
      image: "/images/banner_ring_img2.jpeg",
      buttonText: "Shop Now",
      buttonLink: "/shop"
    },
    {
      id: 3,
      title: "Custom Designs",
      description: "Create your dream jewelry with our bespoke design service",
      image: "/images/banner_ring_img3.jpeg",
      buttonText: "Get Started",
      buttonLink: "/contact"
    }
  ];

  const styles = {
  container: {
    width: '100%',
    height: '70vh', // Reduced from 100vh
    minHeight: '500px', // Reduced from 600px
    position: 'relative',
    marginTop: 40
  },
  slide: {
    display: 'flex',
    height: '100%',
    width: '100%',
    background: '#000'
  },
  contentSide: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '60px 80px',
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    color: 'white'
  },
  title: {
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: '20px',
    color: '#ffffff',
    lineHeight: 1.2,
    letterSpacing: '2px'
  },
  description: {
    fontSize: '1.2rem',
    color: '#cccccc',
    marginBottom: '30px',
    maxWidth: '500px',
    lineHeight: 1.6
  },
  button: {
    padding: '16px 40px',
    fontSize: '1.1rem',
    fontWeight: 600,
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    letterSpacing: '1px'
  },
  imageSide: {
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0' // Remove padding
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover', // Changed back to cover to fill space
    objectPosition: 'center',
    display: 'block'
  }
};

  // Inline styles for Swiper navigation and pagination
  const swiperStyles = `
    .hero-swiper-custom .swiper-button-prev,
    .hero-swiper-custom .swiper-button-next {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(10px);
      width: 50px;
      height: 50px;
      border-radius: 50%;
      transition: all 0.3s ease;
    }

    .hero-swiper-custom .swiper-button-prev:after,
    .hero-swiper-custom .swiper-button-next:after {
      font-size: 20px;
    }

    .hero-swiper-custom .swiper-button-prev:hover,
    .hero-swiper-custom .swiper-button-next:hover {
      background: rgba(255, 255, 255, 0.4);
      transform: scale(1.1);
    }

    .hero-swiper-custom .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #ffffff;
      opacity: 0.5;
    }

    .hero-swiper-custom .swiper-pagination-bullet-active {
      background: #ffffff;
      opacity: 1;
    }

    @media (max-width: 768px) {
      .hero-carousel-responsive {
        height: auto !important;
        min-height: 600px !important;
      }
      
      .hero-slide-responsive {
        flex-direction: column !important;
      }
      
      .hero-content-responsive {
        padding: 40px 30px !important;
        order: 2;
      }
      
      .hero-image-responsive {
        min-height: 350px !important;
        order: 1;
      }
      
      .hero-title-responsive {
        font-size: 2rem !important;
      }
      
      .hero-description-responsive {
        font-size: 1rem !important;
      }
      
      .hero-button-responsive {
        padding: 12px 30px !important;
        font-size: 1rem !important;
      }
    }
  `;

  return (
    <>
      <style>{swiperStyles}</style>
      <div style={styles.container} className="hero-carousel-responsive">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          spaceBetween={0}
          slidesPerView={1}
          style={{ width: '100%', height: '100%' }}
          className="hero-swiper-custom"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div style={styles.slide} className="hero-slide-responsive">
                {/* Text Side */}
                <div style={styles.contentSide} className="hero-content-responsive">
                  <h1 style={styles.title} className="hero-title-responsive">
                    {slide.title}
                  </h1>
                  <p style={styles.description} className="hero-description-responsive">
                    {slide.description}
                  </p>
                  <button 
                    style={styles.button}
                    className="hero-button-responsive"
                    onClick={() => navigate(slide.buttonLink)}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#f0f0f0';
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(255, 255, 255, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#ffffff';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    {slide.buttonText}
                  </button>
                </div>

                {/* Image Side */}
                <div style={styles.imageSide} className="hero-image-responsive">
                  <img 
                    src={slide.image} 
                    alt={slide.title}
                    style={styles.image}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}

export default HeroCarousel;